import WithRender from "../../templates/base/uploadDropzone.html";
import { mapGetters, mapActions } from "vuex";
import { i18n } from "../../i18n.js";

import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import axios from "../../axios-auth";

export default WithRender({
  components: {
    vueDropzone: vue2Dropzone
  },
  computed: {
    ...mapGetters([
      "getShowUpload",
      "getSelectionId",
      "getShowPreviewInUpload",
      "getIsPackingEnabled",
      "getIsPreflighPitstop",
      "getPitstopFileIsLoading",
      "getPitstopFileStatusResponse",
      "getTimer",
      "getUrl",
      "getSelectedOption",
      "getIsMyAccount",
      "getMyAccountUploadedFiles",
      "getToggleReadyToConnect",
      "getNumberOfPP",
      "getNumberOfUploads",
      "getMyAccountUploadPath",
      "getDisableDeleteUploadAfterConnect",
      "getAppSelectionId",
      "getStoreCode",
      "getUploadForProductPart",
      "getFileParameters",
      "getUploadItemId"
    ]),
    refId: function () {
      return this.getUploadItemId(this.propsData.code);
    }
  },
  methods: {
    ...mapActions([
      "setPreview3DImage",
      "pitstopAddFile",
      "uploadFile",
      "setPreflightInfo",
      "uploadLoading",
      "setPreflightData",
      "setAttributeUploadForProductPart",
      "setAttributeMultiUploadForProductPart",
      "setToggleReadyToConnect",
      "setPersonalizeLoading"
    ]),
    // this is appended to the url for the thumbnails of the uploaded artwork
    // to avoid the browser caching the image for subsequent uploads
    getAcceptedFiles: function () {
      var images = ["jpg", "jpeg", "gif", "png", "tif", "tiff"].map(el => {
        return "image/" + el;
      });
      var pdfVT = [".csv", ".xlsx", ".xls", ".zip"];
      return ["application/pdf"].concat(images);
    },
    afterComplete(file) {
      this.setAttributes({
        showPreflight: false,
        pitstopReport: false,
        isLoading: false,
        showRearrange: false,
        uploadedFileRelativePath: null,
        loadingProgress: 0
      });
      this.uploadLoading(false);
      this.setPersonalizeLoading(false);

      if (file.status == "error" && !file.accepted) {
        this.$swal({
          text: i18n.t("File is not in accepted format!"),
          icon: "warning"
        });
        return;
      }
      if (file.status == "success") {
        if (file.xhr.response) {
          var response = JSON.parse(file.xhr.response);
          if (response.success) {
            this.afterUploadFile(
              response.file_data[response.temp_filename],
              response.temp_filename,
              response.file_url
            );
          }
        }
      }
    },
    afterUploadFile: function (file_info, uploadedFile, file_url) {
      this.uploadFile();
      if (this.getIsMyAccount && this.getToggleReadyToConnect) {
        if (this.getNumberOfPP == this.getNumberOfUploads) {
          this.getToggleReadyToConnect(true);
        }
      }

      this.setAttribute("uploadedFile", uploadedFile);
      var pdfFile = false;
      if (file_info) {
        if (file_info.extension && file_info.extension == "PDF") {
          pdfFile = true;
          this.setAttribute("showRearrange", true);
          this.setAttribute("uploadedFileRelativePath", file_info.file);
          if (file_info.preflight) {
            this.setAttribute("showPreflight", true);
            var preflightKeys = Object.keys(file_info.preflight);
            var preflightData = [];
            var preflightInfo = {};
            for (var key of preflightKeys) {
              if (
                file_info.preflight[key] &&
                typeof file_info.preflight[key] == "object"
              ) {
                preflightData.push(file_info.preflight[key]);
              } else {
                preflightInfo[key] = file_info.preflight[key];
              }
            }
            this.setPreflightData({
              code: this.propsData.code,
              preflightData
            });
            this.setPreflightInfo({
              code: this.propsData.code,
              preflightInfo
            });
          } else if (this.getIsPreflighPitstop) {
            this.setAttributes({
              pitstopReport: true,
              uploadedFileHash: file_info.hash
            });
            this.pitstopAddFile({
              name: this.getAttribute("uploadedFile"),
              hash: this.getAttribute("uploadedFileHash"),
              product_part: this.propsData.code
            });
          }
          // set it to preflight row line object
        }
        if (this.getShowPreviewInUpload && file_info.preview) {
          this.setAttribute("previewFile", file_info.preview);
          if (file_info.preview_second) {
            this.setAttribute("previewFileSecond", file_info.preview_second);
          } else {
            this.setAttribute("previewFileSecond", "");
          }
          this.setAttribute(
            "previewFileLink",
            this.getAttribute("previewFile")
          );
          if (pdfFile) {
            this.setAttribute(
              "previewFileLink",
              this.getUrl(axios.getPdfUploadPreview) +
                "?" +
                this.getFileParameters(file_info.file)
            );
          }
          // checkf it it's an image. Then point directly to the main file
          if (["PNG", "JPG", "JPEG", "BMP"].includes(file_info.extension)) {
            this.setAttribute("previewFileLink", file_url);
          }
          this.setAttribute("fileUrl", file_url);
          const img = new Image();
          img.src = this.getAttribute("previewFile");
          img.onload = () => {
            this.setAttribute("previewUploaded", true);
          };
          this.statusUploaded = true;
          this.setAttribute("statusUploaded", true);

          if (this.getIsPackingEnabled) {
            // put the preview in 3D
            this.setPreview3DImage([
              this.getAttribute("previewFile"),
              this.getAttribute("previewFileSecond")
            ]);
          }
        } else {
          this.statusUploaded = true;
          this.setAttributes({ statusUploaded: true, fileUrl: file_url });
        }
      } else {
        this.error("", "Missing file data information", "");
      }
    },
    sendFile: function (file, xhr, formData) {
      this.setAttribute("isLoading", true);
      this.uploadLoading(true);
      this.prepareDropzoneInput();
      formData.append("id", this.propsData.code);
      formData.append("deleteOld", 1);
      if (this.getIsMyAccount && this.getMyAccountUploadPath) {
        formData.append("folder_name", this.getMyAccountUploadPath);
      } else {
        formData.append("folder_name", "tmp." + this.getSelectionId);
      }
      if (this.getAppSelectionId) {
        formData.append("selection", this.getSelectionId);
      }
      if (this.getStoreCode) {
        formData.append("store_code", this.getStoreCode);
      }

      if (this.getIsPackingEnabled) {
        formData.append("packing", 1);
      }
      formData.append(
        "selected_pages",
        this.getSelectedOption({ pp: this.propsData.code, option: "pages" })
      );
      formData.append(
        "selected_format",
        this.getSelectedOption({ pp: this.propsData.code, option: "format" })
      );
      formData.append(
        "selected_paper",
        this.getSelectedOption({ pp: this.propsData.code, option: "paper" })
      );
      if (i18n.locale) {
        formData.append("lang", i18n.locale);
      }
    },
    drop: function (event) {
      if (event.dataTransfer && event.dataTransfer.files) {
        if (event.dataTransfer.files.length != 1) {
          this.$refs[this.refId].dropzone.multipleFilesError = true;
          this.$swal({
            text: i18n.t("Please upload just one file!"),
            icon: "warning"
          });

          return;
        }
      }

      this.setAttribute("isLoading", true);
      //this.uploadLoading(true);
    },

    error: function (file, message, xhr) {
      this.uploadLoading(false);
      this.setAttributes({
        isLoading: false,
        showPreflight: false,
        pitstopReport: false,
        showRearrange: false,
        uploadedFileRelativePath: null
      });
      this.setPersonalizeLoading(false);

      if (message && message.message) {
        this.$swal({
          text: message.message,
          icon: "error"
        });
      } else if (typeof message == "string") {
        this.$swal({
          text: message,
          icon: "error"
        });
      }
      this.$refs[this.refId].removeAllFiles();
    },

    fileAdded: function (file) {
      if (this.$refs[this.refId].dropzone.multipleFilesError) {
        this.$refs[this.refId].dropzone.removeFile(file);
      }
    },
    progress: function (file, progress, bytesSent) {
      if (progress == 100) {
        this.setPersonalizeLoading(true);
      }
      this.setAttribute("loadingProgress", progress);
    },
    mounted: function () {
      this.prepareDropzoneInput();

      if (this.getIsMyAccount) {
        var uploadedFileTmp = this.getMyAccountUploadedFiles(
          this.propsData.code
        );
        if (uploadedFileTmp) {
          this.afterUploadFile(
            uploadedFileTmp,
            uploadedFileTmp.file,
            uploadedFileTmp.original_file_name
          );
        }
      }
      if (this.getIsPackingEnabled) {
        window.document.addEventListener(
          "pqMatrix_paperChanged",
          this.onDelete
        );
      }
    },
    prepareDropzoneInput() {
      var dropzone = this.$refs[this.refId].dropzone;
      dropzone.hiddenFileInput.removeAttribute("multiple");
      dropzone.multipleFilesError = false;
      dropzone.hiddenFileInput.addEventListener("click", function (event) {
        dropzone.multipleFilesError = false;
      });
    },
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    },
    setAttribute: function (key, value) {
      return this.setAttributeUploadForProductPart({
        pp: this.propsData.code,
        key,
        value
      });
    },
    setAttributes: function (obj) {
      return this.setAttributeMultiUploadForProductPart({
        pp: this.propsData.code,
        obj
      });
    }
  },
  data: function () {
    return {
      dropzoneOptions: {
        url: this.$store.getters.getUrl(axios.apiUpload),
        maxFilesize: 100,
        dictDefaultMessage: i18n.t("Upload") + " " + this.propsData.label,
        uploadMultiple: false,
        acceptedFiles: this.getAcceptedFiles().join(","),
        paramName: "qqfile",
        timeout: 0,
        previewTemplate:
          '<div id="template-preview"><div class="dz-preview dz-file-preview well" id="dz-preview-template"><div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div></div></div>'
      }
    };
  },
  props: ["propsData"]
});
